import { Link } from "react-router-dom";
import { Flame } from "lucide-react";

export const Footer = () => (
  <footer className="relative z-10 border-t border-white/5 mt-24" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
      <div className="flex items-center gap-2 text-slate-400 text-sm">
        <Flame className="w-4 h-4 text-amber-500" />
        IdeaForge — le idee le forgia l'AI, il guadagno lo costruisci tu.
      </div>
      <div className="flex gap-6 text-sm text-slate-500">
        <Link to="/pro" className="hover:text-slate-200 transition-colors" data-testid="footer-link-pro">Piano Pro</Link>
        <Link to="/admin" className="hover:text-slate-200 transition-colors" data-testid="footer-link-admin">Area riservata</Link>
      </div>
    </div>
  </footer>
);
